import { titleCase } from 'title-case'

import StoreOrderM from '@/gf/modules/StoreOrder'

import Card from '@/gf/components/Card'
import Breakdown from '@/gf/components/TransactionBreakdown'
import Spinner from '@/gf/components/Spinner'

const OfflineTransactionCard = ({
  offlineTransactions,
  storeOrderState,
  offlineTransactionModalToggler,
  offlineBuyerTransactionModalToggler,
}) => {
  const { loading, data } = offlineTransactions
  const transactions = data?.transactionsSearch.transactions

  const secondaryActions =
    storeOrderState && !StoreOrderM.QUOTE_STATES.includes(storeOrderState)
      ? []
      : [
          {
            id: 1,
            title: 'Add Offline Charge',
            callBack: offlineBuyerTransactionModalToggler.on,
          },
        ]

  return (
    <Card
      title="Offline Transactions"
      primaryFooterAction={{
        id: 2,
        title: 'Add Offline Supply',
        callBack: offlineTransactionModalToggler.on,
      }}
      secondaryFooterActions={secondaryActions}
    >
      {loading ? (
        <Card.Section>
          <Spinner />
        </Card.Section>
      ) : (
        <Card.Section>
          {transactions && transactions.length === 0 && (
            <p className="text-sm text-gray-500">This order has no offline transactions</p>
          )}
          {transactions && transactions.length > 0 && (
            <>
              {transactions.map((txn) => (
                <div key={txn.id} className="pb-8">
                  <div className="pb-1">{titleCase(txn.action)}</div>
                  {txn.supplierInfo && (
                    <div className="pb-1 text-sm text-gray-600 whitespace-pre-wrap overflow-wrap-words">
                      {txn.supplierInfo}
                    </div>
                  )}
                  <div className="pb-2 pt-2 border-t-1 border-gray-300">
                    <Breakdown
                      hideTitle
                      gearflow={txn.gearflow}
                      customer={txn.customer}
                      supplier={txn.supplier}
                    />
                  </div>
                </div>
              ))}
            </>
          )}
        </Card.Section>
      )}
    </Card>
  )
}

export default OfflineTransactionCard
